var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ml-auto mt-1 text-nowrap",class:{ 'text-muted': _vm.textLength <= _vm.maxLength, 'text-danger': _vm.textLength > _vm.maxLength },staticStyle:{"font-size":"80%"}},[_vm._v(" "+_vm._s(_vm.textLength)+" / "+_vm._s(_vm.maxLength)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }